/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { styled } from '@compiled/react';

import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { expValEquals } from '@confluence/feature-experiments';
import type { WithFlagsProps } from '@confluence/flags/entry-points/withFlags.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

import type { EditorPageCoverPictureComponentProps } from '../pageCoverPictureTypes.ts';

// Old styled component (to be removed after migration)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Placeholder = styled.div<{
	dynamicCoverImageHeight?: number;
}>({
	position: 'relative',
	background: token('color.background.accent.gray.subtlest'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) => `${props.dynamicCoverImageHeight}px`,
});

// New @atlaskit/css styles
const placeholderStyles = css({
	position: 'relative',
	backgroundColor: token('color.background.accent.gray.subtlest'),
	borderRadius: token('radius.small'),
	width: '100%',
});

export const EditorPageCoverPicturePlaceholder = withFlags(
	(props: EditorPageCoverPictureComponentProps & WithFlagsProps) => {
		if (!props.hasCoverPicture) {
			return null;
		}

		if (expValEquals('confluence_page_cover_picture_css_migration', 'isEnabled', true)) {
			return (
				<div
					css={placeholderStyles}
					style={{
						height: props.dynamicCoverImageHeight
							? `${props.dynamicCoverImageHeight}px`
							: undefined,
					}}
				/>
			);
		}

		return <Placeholder />;
	},
);
